/* eslint-disable max-len */
/* eslint-disable complexity */
import DispatchersMixin from '@/mixins/dispatchers';
import PeriodicOperations from '@/views/operation-details/operations-add/operation-add-execute-operation/periodic-operations';

export default {
    name: 'RefundOperation',
    mixins: [DispatchersMixin],
    props: {
        newOperationState: {
            type: Object,
            required: true
        },
        productMinimums: {
            type: Object,
            required: true
        },
        periodic: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        PeriodicOperations
    },
    /**
     * @override
     */
    data() {
        return {
            amountSharesIndicatorOptions: [],
            updatesCount: 0,
            isSpinnerVisible: false
        };
    },
    watch: {
        'newOperationState.account_patrimony': {
            handler() {
                this.updateMaxSharesToRefund();
            },
            deep: true
        },
        productMinimums: {
            handler() {
                this.updateMaxSharesToRefund();
            },
            deep: true
        }
    },
    /**
     * @override
     */
    computed: {},
    methods: {
        blockedSharesForSelectedProduct() {
            const patrimony = this.newOperationState.account_patrimony;
            if (!patrimony.length) return 0;

            const productName = this.newOperationState.productSelected && this.newOperationState.productSelected.name;

            const productPatrimony = patrimony.find(item => item.nombre_fondo === productName);

            if (!productPatrimony) return 0;

            return Number(productPatrimony.participaciones_bloqueadas || 0);
        },
        updateMaxSharesToRefund() {
            const selectedProduct = this.newOperationState.productSelected;
            const accountProducts = this.newOperationState.account.products || {};
            const productData = selectedProduct && accountProducts[selectedProduct.key_name];
            const productShares = Number(productData && productData.shares || 0);
            const blockedShares = this.blockedSharesForSelectedProduct();
            const nav = Number(selectedProduct && selectedProduct.net_asset_value || 1);
            const minToMaintain = Number(this.productMinimums.minimum_to_maintain || 0);

            this.newOperationState.maxSharesToRefund = Math.max(
                0,
                productShares - blockedShares - (nav ? minToMaintain / nav : 0)
            );
        },
        setAmountSharesIndicatorOptions() {
            const baseOptions = [
                { key: 'B', name: 'Importe Bruto' },
                { key: 'T', name: 'Total' }
            ];

            if (this.newOperationState.operationTypeSelected.allow_shares) {
                baseOptions.push({ key: 'P', name: 'Participaciones' });
            }

            if (this.newOperationState.operationTypeSelected.allow_net_amount) {
                baseOptions.push({ key: 'I', name: 'Importe Neto' });
            }

            this.amountSharesIndicatorOptions = baseOptions;
        },
        /**
         * @param {String} type of refund
         */
        onChangeRefundType(type) {
            this.newOperationState.operationObj.is_total_redemption = type.key === 'T';
        
            // Reseteamos los valores para evitar valores inconsistentes al cambiar tipo
            this.newOperationState.operationObj.netAmount = null;
            this.newOperationState.operationObj.grossAmount = null;
            this.newOperationState.operationObj.shares = null;
        
            this.newOperationState.keyAddOperation++;
        },
        /**
         * Retrieve bank accounts data
         */
        getBankAccountsData() {
            this.$accountsService.getAccountBankAccounts(this.newOperationState.account.uuid, {}).then(res => {
                const fake = { iban_code: 'Nueva cuenta', is_fake: true };
                // this.newOperationState.account.bankAccounts = res.data.bank_accounts.filter(ba => ba.is_validated);
                this.newOperationState.account.bankAccounts = res.data.bank_accounts;
                this.newOperationState.account.bankAccounts.push(fake);
                this.newOperationState.bankAccount = null;
                this.updatesCount++;
            });
        },
        /**
         * Handle new account
         * @param {Object} selectedBankAccount selectedAccount
         */
        onNewAccount(selectedBankAccount) {
            this.newOperationState.keyAddOperation++;
            if (selectedBankAccount.is_fake) {
                this.newOperationState.bankAccount = null;
                const item = {
                    active: true,
                    name: this.newOperationState.account.id_object,
                    route: {
                        name: 'accounts_uuid',
                        params: {
                            uuid: this.newOperationState.account.uuid
                        },
                        force: true
                    }
                };
                localStorage.setItem(`tabs_account_${this.newOperationState.account.uuid}`, 4);
                this.setMenuTab(item);
            }
        }
    },
    /**
     * @override
     */
    beforeMount() {
        this.setAmountSharesIndicatorOptions();
        this.updateMaxSharesToRefund();
        if (this.newOperationState.isEdition) {
            switch (this.newOperationState.amountSharesIndicator.key) {
                case 'I':
                    this.onInputNetAmount(this.newOperationState.operationObj.netAmount);
                    break;
                case 'B':
                    this.onInputGrossAmount(this.newOperationState.operationObj.grossAmount);
                    break;
                case 'P':
                    this.onInputShares(this.newOperationState.operationObj.shares);
                    break;
                default:
                    break;
            }
        }
    }
};
